<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Setores</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <NewDepartment :dialog="dialog" :closeDialog="closeDialog" :departmentData="departmentData" />
    <v-card-actions class="mt-2 mx-2 pb-0 mb-2 d-flex justify-end">
      <v-btn color="green lighten-1" class="white--text" @click="openDialog({})">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Criar
      </v-btn>
    </v-card-actions>
    <v-data-table v-if="departments" :headers="headers" :items="departments" class="elevation-1">
      <template v-slot:item="{ item }">
        <tr :key="item.id">
          <td class="overflow-x-hidden">
            {{ item.id }}
          </td>
          <td class="overflow-x-hidden">
            {{ item.department }}
          </td>
          <td class="overflow-x-hidden">
            <v-btn text small icon class="mx-2" @click="openDialog(item)">
              <v-icon small class="my-2"> mdi-pencil </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import NewDepartment from './components/NewDepartment'

export default {
  name: 'Admin',
  components: {
    NewDepartment,
  },
  data: function () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Setor', value: 'department' },
        { text: 'Ações', sortable: false },
      ],
      dialog: false,
      departmentData: {},
    }
  },
  computed: {
    ...mapState('utils', ['departments']),
  },
  methods: {
    openDialog(item) {
      if (Object.keys(item).length > 0) {
        this.departmentData = { id: item.id, department: item.department }
      } else {
        this.departmentData = item
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = !this.dialog
    },
  },
}
</script>
